<template>
    <v-bottom-navigation
        app
        fixed
        input-value
        class="footer-menu"
        v-model="active"
    >
        <div class="footer-block">
            <v-btn
                v-for="(route, key) in routes"
                :key="key"
                :to="route.to"
                class="px-0"
                active-class=""
            >
                <span>{{ route.name }} </span>
                <ListIcon v-if="route.icon == 0"/>
                <ClockIcon v-else-if="route.icon == 1"/>
                <ProfileIcon v-else/>
            </v-btn>
        </div>
        <ModalConnect ref="modalErrorConnection"></ModalConnect>
    </v-bottom-navigation>
</template>

<script>
import ClockIcon from "@/assets/icons/ClockIcon";
import ListIcon from "@/assets/icons/ListIcon";
import ProfileIcon from "@/assets/icons/ProfileIcon";
import Centrifuge from "centrifuge";
import {eventBus} from "@/main";
import ModalConnect from "@/components/modals/ModalConnect";

export default {
    name: "FooterMenu",
    components: {
        ClockIcon,
        ListIcon,
        ProfileIcon,
        ModalConnect,
    },
    data() {
        return {
            show: false,
            active: 0,
            routes: [
                { name: 'Устройства', to: '/devices', icon: 0 },
                { name: 'Сценарии', to: '/scenarios', icon: 1 },
                { name: 'Профиль', to: '/profile', icon: 2 },
            ],
            reconnect: false,
        }
    },
    mounted() {
        if (this.$route.query.master_key) {
            this.$router.push({name: "master", query: this.$route.query});
        } else if (this.$store.state.accessToken) {
            this.openWebSocket();
        } else {
            this.$router.push({ name: "empty" });
        }
    },
    computed: {
        notErrorPage() {
            return this.$store.state.accessToken && this.$route && this.$route.name != "empty" && this.$route.name != "final";
        },
    },
    methods: {
        openWebSocket() {
            const centrifuge = new Centrifuge(`${process.env.VUE_APP_WS_API_URL}`, {
                retry: 1000,
                maxRetry: 2000,
            });
            const room_access_key_token = this.$store.state.accessToken;
            centrifuge.setConnectData({'room_access_key': room_access_key_token});
            let is_subscribe = false;

            centrifuge.on('connect', (ctx) => {
                console.log("connected", ctx);
                if (this.reconnect) {
                    this.reconnect = false;
                    eventBus.$emit("reconnect");
                }
                if (this.notErrorPage) {
                    this.$refs.modalErrorConnection.close();
                }
                let room_id = ctx.data.room_id;

                if (!is_subscribe) {
                    centrifuge.subscribe("guest_update:room_" + room_id, (ctx) => {
                        if (ctx.data.notification_type == "scenario") {
                            eventBus.$emit("scenario", {
                                id: ctx.data.scenario.uid,
                                enabled: ctx.data.scenario.enabled,
                            });
                        } else if (ctx.data.notification_type == "device") {
                            eventBus.$emit("device", {
                                device: ctx.data.device
                            });
                        } else if (ctx.data.notification_type == "scenario_group") {
                            eventBus.$emit("scenarioGroup", {
                                group: ctx.data.group
                            });
                        }
                    });
                    is_subscribe = true;
                }
            });

            centrifuge.on('disconnect', (ctx) => {
                console.log("disconnected", ctx);
                this.reconnect = true;
                if (this.$route && this.$route.name != "final" && this.$route.name != "empty") {
                    if (this.notErrorPage) {
                        this.$refs.modalErrorConnection.open();
                    }
                }
            });
            centrifuge.connect();
        },
    },
}
</script>

<style lang="scss" scoped>
.footer-menu.v-bottom-navigation {
    display: flex;
    border-top: 0.35px solid #C1C1C1;
    box-shadow: none;
    height: 56px;
    min-height: 56px;
    max-height: 56px;
    overflow: hidden;

    .footer-block {
        background-color: #FFFFFF;
        max-width: 900px;
        width: 100%;
        padding: 0 24px;
        display: flex;
        justify-content: space-between;
        box-shadow: none;
        height: 56px;
        min-height: 56px;
        max-height: 56px;
        overflow: hidden;
    }

    .v-btn {
        font-weight: 500;
        font-size: 12px;
        line-height: 14px;
        text-align: center;
        color: #130F26;
        opacity: 0.5 !important;

        &.v-btn--active {
            opacity: 1 !important;
            background-color: #FFFFFF;

            &:before {
                content: none;
            }
        }

        span {
            margin-top: 4px;
        }
    }
}
</style>